// extracted by mini-css-extract-plugin
module.exports = {"root":"filebrowser-tiles_root__4rhpJ"};